'use client';

import { useAdContext } from '@/app_lib/providers/AdProvider';
import { NativoData } from '@/app_lib/scripts/nativo/script';

export const NativoScript = () => {
  const { pageAdConfig } = useAdContext();

  if (!pageAdConfig) {
    return null;
  }
  return <NativoData />;
};
